/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
/**
 * This is not a standard DDF component.
 * Used to include buttons into form schema.
 * As out of the box DDF doesn't support this.
 */
import React, { useCallback, useMemo } from 'react';
import { ButtonDDf as Button } from '../Button';
import clsx from 'clsx';
import { useDdf } from '../../context/ddf-context';
import useFormApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-form-api';
import { ModalFooterButtonGroup } from '../Modal/NewModal';

export function FooterButtons({ buttons, hasValidationErrors, className, isInModal }) {
  const { footerOverrides, groupType } = useDdf();
  const { getState } = useFormApi();
  const {
    values: { __footerOverride: currentOverride, ...values }
  } = getState();

  const renderButtons = useCallback(
    (side) => {
      const overrides = currentOverride?.isShown && footerOverrides[currentOverride?.name]?.[side];
      const checkDisabled = ({ type, requireChecked }) => {
        if (type === 'submit') {
          return hasValidationErrors;
        }

        if (requireChecked) {
          if (Array.isArray(values[requireChecked])) {
            return values[requireChecked].filter(({ checked }) => checked).length === 0;
          }

          return values[requireChecked] && !values[requireChecked].checked;
        }

        return false;
      };

      return (
        <span key={side} className="flex flex-row space-x-6">
          {(overrides || buttons[side])
            ?.filter((button) => {
              if (isInModal) {
                return !button.hideInModal;
              }
              return !button.displayOnTypes || button.displayOnTypes.includes(groupType);
            })
            .map((button) => (
              <Button key={button.title} disabled={checkDisabled(button)} {...button} />
            ))}
        </span>
      );
    },
    [currentOverride, footerOverrides, buttons, isInModal, groupType, hasValidationErrors, values]
  );

  const renderedButtons = useMemo(() => ['left', 'right'].map(renderButtons), [renderButtons]);

  return isInModal ? (
    <ModalFooterButtonGroup className="w-full">{renderedButtons}</ModalFooterButtonGroup>
  ) : (
    <div
      className={clsx(
        'flex flex-col pb-16 sm:flex-row sm:flex-wrap justify-between border-t-1 border-gray-20 bottom-0 right-0 px-6 py-5 w-full bg-white z-40 transition-all duration-150',
        className
      )}
    >
      {renderedButtons}
    </div>
  );
}
